/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { AnalyticsWidgetComp, Header } from '../components';

import { vappContainer } from '@/application';
import { useSMProductAnalyticsGetPageContent } from '@pages/AnalyticsPage/machines';
import { AnalyticsPageService } from '@pages/AnalyticsPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<AnalyticsPageService>(
    AnalyticsPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const srv = getSrv();
  const {
    productAnalyticsSend,
    productAnalyticsState,
    productAnalyticsPageMachine,
  } = useSMProductAnalyticsGetPageContent({});
  console.log('render page', productAnalyticsState?.event?.data?.value);

  const onRefresh = () => {
    productAnalyticsSend('TRIGGER_REFRESH', {});
  };

  const _renderAnalytics = () => {
    if (productAnalyticsState?.matches('RENDER_ANALYTICS')) {
      return (
        <>
          <AnalyticsWidgetComp
            {...(productAnalyticsState?.event?.data?.value || {})}
          />
        </>
      );
    }
    if (productAnalyticsState?.matches('GET_ANALYTICS')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingAnalyticsSync()?.loading
            ?.overViewLoading || {})}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getHeaderAnalyticsSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getHeaderAnalyticsSync()?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderAnalytics()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
